import React, { useState, useEffect } from 'react';
import './FireAlarmTools.css'; // Optional: Add custom styles for the table
import '../firebase'
import Table from 'react-bootstrap/Table';

const FireAlarmTools = () => {
    const [devices, setDevices] = useState([]);
    const [tableData, setTableData] = useState(
        Array(37).fill({ device: '', model: '', description: '', standbyCurrent: '', alarmCurrent: '' })
    );

    const deviceList = [
        { id: 1, device: 'Fire Alarm Control Panel', model: 'FAC-1000', description: 'Main control panel for fire alarm system', standbyCurrent: '0.5A', alarmCurrent: '2A' },
    ]
    useEffect(() => {
        const fetchDevices = async () => {
            // const querySnapshot = await getDocs(collection(db, 'devices'));
            // const deviceList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setDevices(deviceList);
        };

        fetchDevices();
    }, []);

    const handleDeviceChange = (index, selectedDevice) => {
        const deviceData = devices.find(device => device.device === selectedDevice);
        const updatedRow = {
            device: selectedDevice,
            model: deviceData?.model || '',
            description: deviceData?.description || '',
            standbyCurrent: deviceData?.standbyCurrent || '',
            alarmCurrent: deviceData?.alarmCurrent || ''
        };

        const updatedTableData = [...tableData];
        updatedTableData[index] = updatedRow;
        setTableData(updatedTableData);
    };

    return (
        <div className="fire-alarm-tools">
            <h1>Fire Alarm Tools</h1>
            <Table striped boarder hover responsive>
                <thead>
                    <tr>
                        <th>Device</th>
                        <th>Model</th>
                        <th>Description</th>
                        <th>Standby Current</th>
                        <th>Alarm Current</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((row, index) => (
                        <tr key={index}>
                            <td>
                                <select
                                    value={row.device}
                                    onChange={(e) => handleDeviceChange(index, e.target.value)}
                                >
                                    <option value="">Select Device</option>
                                    {devices.map(device => (
                                        <option key={device.id} value={device.device}>
                                            {device.device}
                                        </option>
                                    ))}
                                </select>
                            </td>
                            <td>{row.model}</td>
                            <td>{row.description}</td>
                            <td>{row.standbyCurrent}</td>
                            <td>{row.alarmCurrent}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default FireAlarmTools;